import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import routerConstant from "service/constant/routerConstant";
import type { IBurialList } from "service/interface/burial";

interface Props {
  data: IBurialList[];
}

export function BurialListTable({ data }: Props) {
  const navigate = useNavigate();

  const handleTableClick = (id: number) => {
    navigate(`${routerConstant.BURIAL.index}/${id}`);
  };

  return (
    <div className="w-ful">
      <table className="w-full divide-y divide-[#d1dff3]">
        <thead>
          <tr>
            <th
              scope="col"
              className="min-w-[55px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              ID
            </th>
            <th
              scope="col"
              className="min-w-[102px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              운영 형태
            </th>
            <th
              scope="col"
              className="min-w-[112px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              시설명
            </th>
            <th
              scope="col"
              className="min-w-[387.5px] bg-[#f5f8ff] px-[16px] py-[12px] text-left text-table-SM1 text-gray-5"
            >
              주소
            </th>
            <th
              scope="col"
              className="min-w-[112px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              전화번호
            </th>
            <th
              scope="col"
              className="min-w-[201px] bg-[#f5f8ff] px-[16px] py-[12px] text-center text-table-SM1 text-gray-5"
            >
              생성일
            </th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {data.map((burial) => (
            <tr
              key={burial.id}
              className="cursor-pointer even:bg-[#fbfbfb] hover:bg-blue-2"
              onClick={() => handleTableClick(burial.id)}
            >
              <td className="whitespace-nowrap px-[15px] py-[16px] text-M1 text-gray-5">
                {burial.id}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {burial.isPublic ? "공설" : "사설"}
              </td>
              <td className="max-w-[112px] overflow-hidden text-ellipsis whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {burial.name}
              </td>
              <td className="max-w-[387.5px] overflow-hidden text-ellipsis whitespace-nowrap px-[16px] py-[16px] text-left text-M1 text-gray-5">
                {burial.address}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-M1 text-gray-5">
                {burial.telephone}
              </td>
              <td className="whitespace-nowrap px-[16px] py-[16px] text-center text-M1 text-gray-5">
                {moment(burial.createdAt).format("YYYY-MM-DD")}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
